<rwidget-notification-settings *ngIf="!env?.SHOW_LEGACY_NOTIFICATION_SETTINGS_PAGE; else legacyNotificationSettings">
</rwidget-notification-settings>

<ng-template #legacyNotificationSettings>
    <rwidget-legacy-notification-settings></rwidget-legacy-notification-settings>
</ng-template>
